<template functional>
  <span
    :class="{ 'receiving-skeleton-text b-skeleton-animate-fade': props.loading }"
    :aria-hidden="props.loading ? 'true' : null"
  ><slot /></span>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
  },
}
</script>
